export const routes = {
  annual: "annual",
  checkoutSuccess: "checkout-success",
  dashboard: "dashboard",
  onboarding: "onboarding",
  onboardingInfluencer: "start-onboarding",
  onboardingPaywall: "onboarding-paywall",
  onboardingVaInfluencer: "va-onboarding",
  onboardingVaSelfServe: "va-onboarding-self-serve",
  onboardingInstagram: "instagram-onboarding",
  onboardingBrands: "brands",
  signIn: "sign-in",
  signUp: "sign-up",
  founder: "user",
  influencer: "start",
  tracking: "tracking",
  subscriptions: "subscriptions",
  subscriptionsSuccess: "subscription-success",
  repitching: "repitching",
  intakeForms: "intake-forms",
  annualTemplate: "free-template",

  // Fairpay
  fairpay: "fairpay",

  // Self Serve VA Path
  welcomeSelfServeOnboarding: "va-onboarding-self-serve/welcome",
  aboutSelfServeOnboarding: "va-onboarding-self-serve/about",
  nicheSelfServeOnboarding: "va-onboarding-self-serve/niches",
  nichesFollowUpSelfServeOnboarding:
    "va-onboarding-self-serve/niches-follow-up",
  templatesSelfServeOnboarding: "va-onboarding-self-serve/templates",
  preferencesSelfServeOnboarding: "va-onboarding-self-serve/preferences",
  emailWarmupSelfServeOnboarding: "va-onboarding-self-serve/email-warmup",
  connectGmailSelfServeOnboarding: "va-onboarding-self-serve/connect-gmail",
  reviewSelfServeOnboarding: "va-onboarding-self-serve/review",

  // Non-VA Path
  preferencesOnboarding: "start-onboarding/preferences",
  aboutOnboarding: "start-onboarding/about",
  categoryOnboarding: "start-onboarding/category",
  income: "start-onboarding/income",
  finalOptIn: "start-onboarding/opt-in",

  // Demo Onboarding Path
  welcomeOnboardingDemo: "onboard/welcome",
  aboutOnboardingDemo: "onboard/about",

  // Instagram Onboarding
  aboutInstagramOnboarding: "instagram-onboarding/about",
  categoryInstagramOnboarding: "instagram-onboarding/category",
  preferencesInstagramOnboarding: "instagram-onboarding/preferences",
  signUpInstagramOnboarding: "instagram-onboarding/sign-up",
  signInInstagramOnboarding: "instagram-onboarding/sign-in",

  // Dashboard
  subscribe: "dashboard/subscribe",
  home: "dashboard/home",
  inbox: "dashboard/inbox",
  brands: "dashboard/brands",
  pitchLocal: "dashboard/local",
  opportunities: "dashboard/opportunities",
  settings: "dashboard/settings",
  profile: "dashboard/profile",
  templates: "dashboard/templates",
  pitchTrackerImport: "pitch-tracker/import",
  recommendations: "dashboard/recommendations",
  virtualAssistant: "dashboard/virtual-assistant",

  recommendationsSaved: "dashboard/recommendations/saved",
  recommendationsBento: "dashboard/recommendations/bento",
  actionItem: "/dashboard/home/action",

  inboxMain: "dashboard/inbox/inbox",
  inboxSent: "dashboard/inbox/sent",
  inboxScheduled: "dashboard/inbox/scheduled",
  inboxCheckins: "dashboard/inbox/checkins",
  inboxBrandTracker: "dashboard/inbox/brand-tracker",

  // Tracking
  trackingView: "dashboard/tracking/view",

  // Campaigns
  campaignView: "dashboard/campaigns",

  // Templates
  create: "create",
  new: "new",
  import: "import",
  newTemplate: "new-template",

  // QuickSend
  outreachSend: "dashboard/outreach/send",
  discoverSend: "dashboard/brands/all/send",

  // OOO Collaboration
  pitchPlease: "pitch-please",
  pitchPleaseSignUp: "pitch-please/sign-up",
  pitchPleaseSignIn: "pitch-please/sign-in",

  // Pro Bundle
  proBundle: "pro-bundle",
  proBundleSignUp: "pro-bundle/sign-up",
  proBundleSignIn: "pro-bundle/sign-in",

  // VA Annual
  vaAnnual: "va-money-back",
  vaAnnualSignUp: "va-money-back/sign-up",
  vaAnnualSignIn: "va-money-back/sign-in",

  // Va Annual Sign Up (With Booked Call)
  vaAnnualBooked: "va-moneyback",
  vaAnnualBookedSignUp: "va-moneyback",
  vaAnnualBookedSignIn: "va-moneyback/sign-in",

  // Repitching
  repitchingIntakeForm: "repitching/intake-form",

  // Splash Page
  pro: "pro",
  va: "va",
  vaBundled: "va-bundled",
  vaBundledIntakeForm: "va-bundled/intake-form",
  strategyPackage: "strategy-package",
};

export const isOnPage = (path: string) => {
  return window.location.href?.includes(path);
};

export type Route = {
  name: string;
  element: any;
};
